// src/App.js
import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import HomePage from "./components/pages/homepage";
import ManifestoPage from "./components/pages/manifesto";
import WaitlistPage from "./components/pages/waitlistpage";
import DemoPage from "./components/pages/demo";
import AboutPage from "./components/pages/about";
import TryItPage from "./components/pages/tryit";
import ContactPage from "./components/pages/contact";
import ScrollToTop from "./scrolltoptop";

function RootRedirect() {
  const location = useLocation();
  return <Navigate to={`/home${location.search}`} replace />;
}

function AppRoutes() {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>


      <Route path="/" element={<RootRedirect />} />

      <Route path="/home" element={<HomePage />} />
      <Route path="/manifesto" element={<ManifestoPage />} />
      <Route path="/waitlist" element={<WaitlistPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/tryit" element={<TryItPage />} />
      <Route path="/contact" element={<ContactPage />} />
    </Routes>
  );
}

export default function App() {
  return <AppRoutes />;
}
